interface WaitlistProgressProps {
  step: number;
}

export const WaitlistProgress = ({ step }: WaitlistProgressProps) => (
  <div className="mb-8">
    <div className="h-2 w-full overflow-hidden rounded-full bg-surface-sunken">
      <div
        className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
        style={{ width: `${(step / 3) * 100}%` }}
      />
    </div>
  </div>
);
